module.exports = __webpack_public_path__ + "static/media/1920.00c3467c.jpg";